class BondAgencyQuestionsSchemaParser {
    // Parse a schema and replace defaults that reference URL params like "?param"
    // - schema: object to clone and mutate
    // - urlSearch: optional search string (defaults to window.location.search in browser)
    public static parse(schema: any, urlSearch?: string) {
        if (!schema) return schema;

        try {
            const search = (typeof urlSearch === "string")
                ? urlSearch
                : window.location.search;
            const params = new URLSearchParams(search);
            const newSchema = JSON.parse(JSON.stringify(schema));

            const walk = (node: any) => {
                if (!node || typeof node !== "object") return;

                parseDefaultValue(node);

                walkProperties(node, walk);
                walkDefinitions(node, walk);
                walkItems(node, walk);
                walkComposition(node, walk);
                walkConditionals(node, walk);

                walkPatternProperties(node, walk);
                walkAdditionalProperties(node, walk);
            };

            const parseDefaultValue = (node: any) => {
                if (typeof node.default !== "string" || !node.default.startsWith("?")) return;
                const paramName = node.default.substring(1);
                const raw = params.get(paramName);
                let value: any = "";
                if (raw === null) {
                    value = "";
                } else {
                    const lower = raw.toLowerCase();
                    if (lower === "true") value = true;
                    else if (lower === "false") value = false;
                    else value = raw;
                }
                node.default = value;
            };

            const walkProperties = (node: any, walk: (n: any) => void) => {
                if (!node.properties || typeof node.properties !== "object") return;
                Object.values(node.properties).forEach((child: any) => walk(child));
            };

            const walkDefinitions = (node: any, walk: (n: any) => void) => {
                if (!node.definitions || typeof node.definitions !== "object") return;
                Object.values(node.definitions).forEach((child: any) => walk(child));
            };

            const walkItems = (node: any, walk: (n: any) => void) => {
                if (!node.items) return;
                if (Array.isArray(node.items)) node.items.forEach((it: any) => walk(it));
                else walk(node.items);
            };

            const walkComposition = (node: any, walk: (n: any) => void) => {
                ["allOf", "oneOf", "anyOf"].forEach((comp) => {
                    if (!Array.isArray(node[comp])) return;
                    node[comp].forEach((child: any) => walk(child));
                });
            };

            const walkConditionals = (node: any, walk: (n: any) => void) => {
                ["if", "then", "else"].forEach((key) => {
                    if (!node[key]) return;
                    if (Array.isArray(node[key])) node[key].forEach((child: any) => walk(child));
                    else walk(node[key]);
                });
            };

            const walkPatternProperties = (node: any, walk: (n: any) => void) => {
                if (node.patternProperties && typeof node.patternProperties === "object") {
                    Object.values(node.patternProperties).forEach((child: any) => walk(child));
                }
            };

            const walkAdditionalProperties = (node: any, walk: (n: any) => void) => {
                if (node.additionalProperties && typeof node.additionalProperties === "object") {
                    walk(node.additionalProperties);
                }
            };

            walk(newSchema);
            return newSchema;
        } catch (e) {
            return schema;
        }
    }
}

export default BondAgencyQuestionsSchemaParser;
